import React, { useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import logo from "../../../images/logo.png";
import Barcode from "react-barcode";
import "./print.css";
import citiesData from "../../../cities/cities.json";
export type order = {
  alto: string;
  ancho: string;
  bultos: string;
  ciudad: string;
  contacto: string;
  destinatario: string;
  direccion: string;
  email: string;
  guia: string;
  kilos: string;
  largo: string;
  observaciones: string;
  fecha: string;
};

export const ComponentToPrint = React.forwardRef((props, ref: any) => {
  const node = useRef<HTMLDivElement>();
  const ordersAux: order[] = Object.values(props);
  const [orders, setOrders] = useState<any[]>([]);
  const ordersP: order[] = [];
  //console.log("ordersAux:", ordersAux);

  //const item: any = ordersAux[0];
  //const array: any[] = item["fecha"].split(",");
  //const array2: any[] = array[1].split(" ");
  //const fn = array[2].replace(":", "").replace(":", "");
  //console.log(array2[1] + "" + array2[5]);
  const ordersNew: order[] = [];
  ordersAux.forEach((e) => {
    //console.log(typeof e.bultos)
    if (parseInt(e.bultos) === 1) {
      ordersNew.push(e);
    } else {
      for (let i = 0; i < parseInt(e.bultos); i++) {
        ordersNew.push(e);
      }
    }
  });
  //console.log(ordersNew);
  //console.log(ordersAux)
  return (
    <div ref={ref}>
      <Container>
        {props !== null &&
          ordersNew.map((variant: any, index) => (
            /*console.log(variant);*/ /*console.log(typeof variant.uuid);*/ <Row
              className={"page-break"}
              key={index}
            >
              <Col sm={12}>
                <div
                  style={{
                    border: "3px solid",
                    borderRadius: "1rem 1rem 1rem 1em ",
                    borderColor: "#202156",
                    maxWidth: "92%",
                    marginLeft: "0.4rem",
                    marginTop: "0.1rem",
                    overflow: "hidden",
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    {/* Columna izquierda */}
                    <div style={{ flex: 1, paddingLeft: "0.5rem", paddingTop: "0.2rem", paddingBottom: "0.3rem" }}>
                      <p style={{ color: "#202156", fontSize: 11, fontWeight: 600, margin: "0 0 0.1rem 0" }}>
                        {variant.fecha}
                      </p>
                      <p style={{ color: "#202156", fontSize: 11, fontWeight: 600, margin: "0 0 0.1rem 0" }}>
                        {variant.guia === "." ? variant.uuid : variant.guia}
                      </p>
                      <p style={{ color: "#202156", fontSize: 15, fontWeight: 600, margin: "0 0 0.1rem 0", wordWrap: "break-word", whiteSpace: "normal" }}>
                        DESTINATARIO : {variant.destinatario}
                      </p>
                      <p style={{ color: "#202156", fontSize: 15, fontWeight: "bold", margin: "0 0 0.1rem 0", wordWrap: "break-word", whiteSpace: "normal" }}>
                        CLIENTE: {variant.client}
                      </p>
                      <p style={{ color: "#202156", fontSize: 15, fontWeight: 600, margin: "0 0 0.1rem 0" }}>
                        BULTOS : {variant.bultos} PESO : {variant.kilos} kg
                      </p>
                      <p style={{ color: "#202156", fontSize: 15, fontWeight: 600, margin: "0 0 0.1rem 0" }}>
                        TELEFONO : {variant.contacto}
                      </p>
                      <p style={{ color: "#202156", fontSize: 15, fontWeight: 600, margin: "0 0 0.1rem 0", wordWrap: "break-word", whiteSpace: "normal" }}>
                        ORIGEN :{" "}{citiesData[variant.ciudad as keyof typeof citiesData]}
                      </p>
                      <p style={{ color: "#202156", fontSize: 16, fontWeight: 600, margin: "0 0 0.1rem 0" }}>
                        DESTINO :{" "}{citiesData[variant.Destino as keyof typeof citiesData]}
                      </p>
                      <p style={{ color: "#202156", fontSize: 12, fontWeight: 600, margin: "0 0 0.1rem 0" }}>
                        LARGO: {variant.largo} cm, ALTO: {variant.alto} cm, ANCHO: {variant.ancho} cm
                      </p>
                      <p style={{ color: "#202156", fontSize: 13, fontWeight: 600, margin: "0", wordWrap: "break-word", whiteSpace: "normal" }}>
                        DIRECCION : {variant.direccion}
                      </p>
                    </div>
                    {/* Columna derecha */}
                    <div style={{ width: "35%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-start", paddingTop: "0.2rem" }}>
                      <img style={{ height: 80 }} src={logo} alt="logo" />
                      <Barcode value={`${variant.uuid}`} height={20} width={1.8} fontSize={25} />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          ))}
      </Container>
    </div>
  );
});
